import React, { FC } from 'react'
import { Typography } from '../ui/Typography'

export const VersionPage: FC = () => {
  return (
    <Typography fontSize={16} fontWeight={400}>
      {process.env.RELEASE_DATE || 'unknown'}
    </Typography>
  )
}

export const versionPagePath = '/version'
